import { MedicalType } from "@qendo/medical/types";
import { useLocalSearchParams } from "expo-router";
import { ImmunisationForm } from "~/components/form/health-profile/ImmunisationForm";
import { Authorize } from "~/components/permission/Authorize";
import { Dismiss } from "~/components/permission/Dismiss";
import { useDismiss } from "~/providers/DismissProvider";
import { useMedical } from "~/providers/MedicalProvider";

const type = MedicalType.immunisation;

export default function EditImmunisation() {
    const { id }: { id: string } = useLocalSearchParams();
    const { findMedical } = useMedical();
    const { handleDismiss } = useDismiss();
    const immunisation = findMedical(type, id);

    if (!immunisation) {
        return <Dismiss />;
    }

    return (
        <Authorize ability="update" section="immunisations">
            <ImmunisationForm immunisation={immunisation} onRequestClose={handleDismiss} asRoute />
        </Authorize>
    );
}
